import CommandHelmGetRepoSnippet from "../../../../contents/docs/self-host/deploy/snippets/command-helm-get-repo";
import CommandHelmUpgradeSnippet from "../../../../contents/docs/self-host/deploy/snippets/command-helm-upgrade";
import * as React from 'react';
export default {
  CommandHelmGetRepoSnippet,
  CommandHelmUpgradeSnippet,
  React
};